import Snowflake from './snowflake';

export default class Elements {
  constructor() {
    this.bounds = {};
    this.elements = {};
    this.canvas = document.createElement('canvas');
    this.canvasCtx = this.canvas.getContext('2d');
    this.canvasCtx.font = '400 normal 32px "Gloria Hallelujah", "Caveat", cursive';
    this.gen = new Snowflake();
  }

  id() {
    return this.gen.id();
  }

  put(id, el) {
    this.elements[id] = el;
    if (el.stroke) {
      const b = {
        l: -Infinity, t: -Infinity, r: Infinity, b: Infinity,
      };
      el.stroke.points.forEach((p) => {
        if (p.x < b.l) b.l = p.x;
        if (p.x > b.r) b.r = p.x;
        if (p.y < b.t) b.t = p.y;
        if (p.y > b.b) b.b = p.y;
      });
      this.bounds[id] = b;
    } else if (el.text) {
      const p = el.text.position;
      const w = this.measure(el.text.text);
      const h = 32;
      this.bounds[id] = {
        l: p.x, t: p.y - h, r: p.x + w, b: p.y,
      };
    }
  }

  measure(text) {
    return this.canvasCtx.measureText(text).width;
  }

  get(id) {
    return this.elements[id];
  }

  rm(id) {
    delete this.bounds[id];
    delete this.elements[id];
  }

  map(cb) {
    return Object.keys(this.elements).map(id => cb(this.elements[id], id));
  }

  nearby(x, y, id, dist) {
    if (x > this.bounds[id].l - dist
        && y > this.bounds[id].t - dist
        && x < this.bounds[id].r + dist
        && y < this.bounds[id].b + dist) {
      const el = this.elements[id];
      if (el.text) {
        return true;
      }
      if (el.stroke) {
        const p = el.stroke.points;
        if (p.length < 2) {
          return true;
        }
        const D = dist ** 2;
        const distSqr = (a, b) => ((a.x - b.x) ** 2) + ((a.y - b.y) ** 2);
        for (let i = 1; i < p.length; i += 1) {
          const a = p[i - 1];
          const b = p[i];
          const c = { x, y };
          const n = distSqr(a, b);
          if (n === 0) {
            if (distSqr(c, a) < D) {
              return true;
            }
          } else {
            let t = (((c.x - a.x) * (b.x - a.x)) + ((c.y - a.y) * (b.y - a.y))) / n;
            t = Math.max(0, Math.min(1, t));
            if (distSqr(c, {
              x: a.x + (t * (b.x - a.x)),
              y: a.y + (t * (b.y - a.y)),
            }) < D) {
              return true;
            }
          }
        }
        return false;
      }
    }
    return false;
  }
}
